import type { ICellRendererParams } from 'ag-grid-community'
import React from 'react'
import type { AttendancePlayer } from '../../types'
import { isUnconfirmedRosterSpare } from '@sportninja/common/features/game/attendance/utils/rosterSpareConfirm'
import { isWaiverLocked } from '@sportninja/common/features/game/attendance/utils/waiverLock'
import { canEditAvailability } from '@sportninja/common/features/game/attendance/utils/attendanceAccess'
import {
  ROSTER_ATTENDANCE_TOOLTIP_BY_VALUE,
  UNCONFIRMED_ROSTER_SPARE_TOOLTIP_BY_VALUE,
} from '../../utils/statusCopy'
import AttendanceAvailIcons from '../AttendanceAvailIcons'
import { useAttendanceSection } from './AttendanceSectionContext'

/** ATTENDING / AVAILABLE column: the Yes / Maybe / No icons (roster rows). */
const AvailabilityCell = ({ data }: ICellRendererParams<AttendancePlayer>) => {
  const {
    waiverEnforced,
    isSpareCandidate,
    availYesNoOnly,
    isRosterSpares,
    promotedRequestById,
    isReadOnly,
    ownPlayerIds,
    onPressAttendanceStatus,
  } = useAttendanceSection()

  if (!data) {
    return null
  }

  return (
    <AttendanceAvailIcons
      attendanceStatus={data.attendance_status}
      disabled={
        isWaiverLocked(data, waiverEnforced, isSpareCandidate) ||
        data.is_suspended
      }
      readOnly={!canEditAvailability(data.id, { isReadOnly, ownPlayerIds })}
      yesNoOnly={availYesNoOnly}
      // Roster rows say Attending; Roster Spares say Available (the default
      // copy), with their own wording until a team official confirms them.
      tooltipByValue={
        !isRosterSpares
          ? ROSTER_ATTENDANCE_TOOLTIP_BY_VALUE
          : isUnconfirmedRosterSpare(data, promotedRequestById)
          ? UNCONFIRMED_ROSTER_SPARE_TOOLTIP_BY_VALUE
          : undefined
      }
      onPress={(next) => {
        const result = onPressAttendanceStatus(data.id, next)
        if (result && typeof result.catch === 'function') {
          result.catch(() => {})
        }
      }}
    />
  )
}

export default AvailabilityCell
